import React from 'react'
import { useSession, useSettings } from 'yordex-ui-kit'
import AdminHomeRedirect from './AdminHomeRedirect'
import DefaultHomeRedirect from './DefaultHomeRedirect'

const HomeRedirect = () => {
  const { session } = useSession()
  const { uiSettings } = useSettings()

  if (session && uiSettings) {
    const isAdmin = session.roles?.includes('ROLE_TRADER_ADMIN')
    if (isAdmin) {
      return <AdminHomeRedirect />
    }
  }
  return <DefaultHomeRedirect />
}

export default HomeRedirect
